import React from "react";
import { useLocation } from "react-router-dom";
import "../App.css";

const ProjectDetails = () => {
  const location = useLocation();

  const images = location?.state?.screenShots;
  const live = location?.state?.live;
  const client = location?.state?.client;
  const server = location?.state?.server;
  const features = location?.state?.features;

  console.log(live, client, server);

  return (
    <div>
      <section>
        <section className="mt-12 project">
          <h2>Features</h2>
          <p>{features}</p>
        </section>
        <section className="flex justify-content-center items-center">
          <a href={live}>
            <button
              type="button"
              className="px-8 py-3 font-semibold rounded border-gray-200 "
            >
              Live Site
            </button>
          </a>
          <a href={client}>
            <button
              type="button"
              className="px-8 py-3 font-semibold rounded border-gray-200 "
            >
              Client Side Code
            </button>
          </a>
          <a href={server}>
            <button
              type="button"
              className="px-8 py-3 font-semibold rounded border-gray-200 "
            >
              Server Side Code
            </button>
          </a>
        </section>
        <section className="py-6 ">
          <div className="container grid grid-cols-2 gap-4 p-4 mx-auto md:grid-cols-2">
            {images?.map((image, index) => (
              <img key={index} src={image} alt="" />
            ))}
          </div>
        </section>
      </section>
    </div>
  );
};

export default ProjectDetails;
